import { AppsList } from './AppsList';
import { SpotLight } from './SpotLight';

export function AppSwitcherInside() {
  return (
    <>
      <SpotLight />
      <AppsList />
    </>
  );
}
